import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./styles";
const Notify = (props) => {
  const { notifyProps } = props;
  const classes = styles();

  useEffect(() => {
    toggleToast();
  }, [notifyProps]);

  const toggleToast = () => {
    switch (notifyProps.type) {
      case "success":
        success();
        break;

      case "error":
        error();
        break;

      case "info":
        info();
        break;
      case "long":
        longSucess();
        break;
      case "warn":
        warningInfo();
        break;
      default:
        break;
    }
  };

  function success() {
    toast.success(notifyProps.message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      Type: notifyProps.type,
      className: classes.successtoaster,
    });
  }
  function error() {
    toast.error(notifyProps.message, {
      position: "top-center",
      autoClose: 10000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      Type: notifyProps.type,
      className: classes.errortoaster,
    });
  }
  function info() {
    toast.info(notifyProps.message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      Type: notifyProps.type,
      className: classes.infotoaster,
    });
  }
  function longSucess() {
    toast.success(notifyProps.message, {
      position: "top-center",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      Type: notifyProps.type,
      className: classes.successlongtoaster,
      autoClose: 5000,
    });
  }
  function warningInfo() {
    toast.warn(notifyProps.message, {
      position: "top-center",
      autoClose: false,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      Type: notifyProps.type,
    });
  }
  return notifyProps.toggle ? <ToastContainer /> : null;
};
export default Notify;
